import React from 'react'
import PropTypes from 'prop-types'
import { withTranslationCustom } from 'lib/i18next'
import { flowRight } from 'lodash'
import { withErrorBoundary } from 'lib/errorBoundary'
import * as Yup from 'yup'
import * as Nope from 'lib/utils/validation/Nope'

import { Field, Form, Formik } from 'formik'
import TextArea from 'components/Forms/FormElements/TextArea'
import Button from 'components/UI/Button'

import './bos-cancel-form.pcss'

const initialValues = {
    reason: '',
}

class BosCancelForm extends React.Component {
    getFormSchema = () => {
        const { requireReason } = this.props

        if (!requireReason) return false

        return Nope.schema({
            reason: Yup.string()
                .max(255, 'formElements:validation.tooLong')
                .required('formElements:validation.required'),
        })
    }

    handleAbort = () => {
        this.props.onAbort && this.props.onAbort()
    }

    renderForm () {
        const {
            t,
            requireReason,
            onSubmit,
            reasonLabel,
            reasonPlaceholder,
            submitText,
        } = this.props

        return (
            <Formik
                initialValues={initialValues}
                validationSchema={this.getFormSchema()}
                onSubmit={async (values, actions) => {
                    await onSubmit(values)
                        .then((result) => {
                            actions.setSubmitting(false)
                            actions.resetForm()

                            return Promise.resolve(result)
                        })
                        .catch(() => {
                            actions.setSubmitting(false)
                        })
                }}
            >
                {({ isSubmitting }) => {
                    return (
                        <Form noValidate className="bos-cancel-form">
                            {requireReason && (
                                <Field
                                    name="reason"
                                    component={TextArea}
                                    rows={4}
                                    label={reasonLabel}
                                    placeholder={reasonPlaceholder}
                                    required
                                />
                            )}

                            <div className="action-wrapper">
                                <Button
                                    type="button"
                                    trackName="abort"
                                    onClick={this.handleAbort}
                                    className="button"
                                    disabled={isSubmitting}
                                >
                                    {t('common:abort')}
                                </Button>
                                <Button
                                    trackName="submit"
                                    type="submit"
                                    className="button button--delete"
                                    disabled={isSubmitting}
                                >
                                    {submitText}
                                </Button>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        )
    }

    render () {
        return this.renderForm()
    }
}

BosCancelForm.propTypes = {
    bos: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    requireReason: PropTypes.bool.isRequired,
    reasonLabel: PropTypes.string.isRequired,
    reasonPlaceholder: PropTypes.string.isRequired,
    submitText: PropTypes.string.isRequired,
    onAbort: PropTypes.func,
}

BosCancelForm.defaultProps = {}

export default flowRight(
    withErrorBoundary,
    withTranslationCustom(['billOfSale', 'common', 'formElements']),
)(BosCancelForm)
